import {InstitutionsState, Status} from './types'

import {Certificate} from '@/store/modules/certificates/types'
import {ModuleFc} from '@/project'
import {sortBy} from 'lodash'
import {updateObject} from '@/store/utils'
import {BizProperty} from '../gtm/types'

export {InstitutionsState}

const initState: InstitutionsState = {
  institutions: [],
  institution: {},
  failedInstitutions: [],
}

const module: ModuleFc<InstitutionsState> = (ctx) => ({
  namespaced: true,
  state: {
    ...initState,
  },
  getters: {
    hometaxStatus(state): Status {
      if(state.institutions.length) {
        const hometax: any = state.institutions.find((institution: any) => {
          return institution.name === 'hometax'
        })
        const {status} = hometax || {}
        return status
      }
      return 'pending'
    },
    giroStatus(state): Status {
      if(state.institutions.length) {
        const giro: any = state.institutions.find((institution: any) => {
          return institution.name === 'giro'
        })
        const {status} = giro || {}
        return status
      }
      return 'pending'
    },
    popbillStatus(state): Status {
      if(state.institutions.length) {
        const popbill: any = state.institutions.find((institution: any) => {
          return institution.name === 'popbill'
        })
        const {status} = popbill || {}
        return status
      }
      return 'pending'
    },
    bankStatus(state) {
      if(state.institutions.length) {
        const bank: any = state.institutions.find((institution: any) => {
          return institution.type === 'bank'
        })
        const {status} = bank || {}
        return status
      }
      return 'pending'
    },
    eiStatus(state) {
      if(state.institutions.length) {
        const ei: any = state.institutions.find((institution: any) => {
          return institution.type === 'ei'
        })

        const {status} = ei || {}
        return status
      }
      return 'pending'
    },
    approachExpiryCert(state) {
      const filteredCerts = [...state.institutions].filter((cert) => {
        return cert.restExpiryDate !== null && cert.restExpiryDate >= 0 && cert.status === 'success'
      })
      const mostApproachCert = sortBy(filteredCerts, [
        (cert) => {
          if(cert.restExpiryDate && cert.restExpiryDate >= 0 && cert.status === 'success') {
            return cert.restExpiryDate
          }
        },
      ])
      return mostApproachCert[0] || null
    },
    gtmInfo(state, getter): BizProperty {
      return {
        hometax_status: getter.hometaxStatus === 'success',
        giro_status: getter.giroStatus === 'success',
        bank_status: getter.bankStatus === 'success',
        popbill_status: getter.popbillStatus === 'success',
        kcomwel_status: getter.eiStatus === 'success'
      }
    }
  },
  actions: {
    async getCertInstitutions({commit, rootState}, payload: {bizId?: string} = {}) {
      const result = await ctx.$axios({
        url: '/institutions',
        method: 'get',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
        },
      })
      commit('updateAll', result.data)
    },
    async getEachInstitution({commit, rootState}, payload: {
      bizId?: string, type: string, code: string
    }) {
      const result = await ctx.$axios({
        url: '/institutions/$id',
        method: 'get',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          type: payload.type,
          code: payload.code,
        },
      })
      commit('updateEachInstitution', result.data)
      return result.data
    },
    async getFailedInstitutions({commit, rootState}, payload: {
      bizId?: string, type: string, name: string
    }) {
      const result = await ctx.$axios({
        url: '/failed-institution/$id',
        method: 'get',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          type: payload.type,
          name: payload.name,
        },
      })
      commit('updateFailed', result.data.results)
    },
    updateInstitution({rootState}, payload: {
      bizId?: string, name: string, type: string,
    }) {
      return ctx.$axios({
        url: '/institution/$id',
        method: 'patch',
        params: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          name: payload.name,
          type: payload.type,
        },
      })
    }
  },
  mutations: {
    updateAll(state, payload: []) {
      state.institutions = payload
    },
    updateEachInstitution(state, payload: []) {
      state.institution = payload
    },
    updateFailed(state, payload: Certificate[]) {
      updateObject(state.failedInstitutions, payload)
    },
    clearFailed(state) {
      state.failedInstitutions = []
    }
  },
})

export default module
